// Per-person conveniences kept in this browser only (remembered collapsed groups, a dismissed bar).
// Never shared data. Storage can be blocked or empty (a private window, cleared site data), so every
// read and write is wrapped and falls back to the default.

type Kind = 'local' | 'session';

function store(kind: Kind): Storage | null {
  try {
    return kind === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}

export function readJson<T>(
  kind: Kind,
  key: string,
  fallback: T,
  valid: (v: unknown) => v is T,
): T {
  try {
    const raw = store(kind)?.getItem(key);
    if (!raw) return fallback;
    const value: unknown = JSON.parse(raw);
    return valid(value) ? value : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson(kind: Kind, key: string, value: unknown): void {
  try {
    store(kind)?.setItem(key, JSON.stringify(value));
  } catch {
    // Blocked or full: the page keeps working with what is on screen.
  }
}

/** The key for one person and one page, so two people on one computer never share a choice. */
export const personKey = (what: string, userId: string, page: string) =>
  `safeside.${what}.v1.${userId}.${page}`;
